import React from 'react';
import { observable, action } from 'mobx';
import { makeApi, URLS } from 'Utils/apiUtil';
import { observer } from 'mobx-react';
import advSearchState from 'Stores/advSearch';
import { savedSearches } from 'Utils/commonApi';
import companySearchState from 'Stores/companySearch';
import Button from 'Components/common/Button';
import { purchaseStatusPopupState } from 'Components/common/purchaseStatusPopup';
import userDetail from 'Stores/userDetail';
import { Utils } from 'Utils/utils';
import * as CONSTANTS from 'Utils/constants';
import { ReactComponent as CloseIcon } from '../../../assets/svg/close-material.svg';
import { ReactComponent as RadioInnerIcon } from '../../../assets/svg/radio-inner-icon.svg';
import { ReactComponent as RadioOuterIcon } from '../../../assets/svg/radio-outer-icon.svg';

class CreateSaveSearchState {
  @observable showCreateSaveSearch = false;

  @observable actionMethod = 'create';

  @observable updateValues = {};

  @observable searchType = '';

  @observable callback;

  @action
  setCallback = val => {
    this.callback = val;
  };

  @action
  setSearchType = val => {
    this.searchType = val;
  };

  @action
  setActionMethod = val => {
    this.actionMethod = val;
  };

  @action
  setUpdateValues = val => {
    this.updateValues = val;
  };

  @action
  setShowCreateSaveSearch = val => {
    this.showCreateSaveSearch = val;
    // eslint-disable-next-line curly
    if (val) {
      // eslint-disable-next-line no-undef
      document.getElementsByTagName('body')[0].classList.add('scrollHidden');
      // eslint-disable-next-line curly
    } else {
      // eslint-disable-next-line no-undef
      document.getElementsByTagName('body')[0].classList.remove('scrollHidden');
    }
  };
}
const createSaveSearchState = new CreateSaveSearchState();

const CreateSaveSearch = observer(props => {
  const [errorToolTip, showErrorToolTip] = React.useState(false);
  const [inputVal, setInputVal] = React.useState('');
  const [emailFrequency, setEmailFrequency] = React.useState('WEEKLY');
  const [isLoading, setIsLoading] = React.useState(false);

  const changeEmailFrequency = (e, value) => {
    setEmailFrequency(value);
  };

  const changeInputVal = value => {
    showErrorToolTip(false);
    setInputVal(value);
  };

  const createSaveSearch = () => {
    const inputValue = inputVal.trim();
    let currentSelectedState;
    if (createSaveSearchState.searchType === 'contact')
      currentSelectedState = advSearchState;
    else currentSelectedState = companySearchState;

    if (!isLoading)
      if (inputValue !== '') {
        setIsLoading(true);
        if (createSaveSearchState.actionMethod === 'update') {
          const updateSaveSearchCallback = (searchType, status = 'success') => {
            setIsLoading(false);
            let str = '';
            if (status === 'success') {
              str = 'Search updated successfully';
              savedSearches(searchType);
            } else {
              str = 'Unable to update this search, please try again';
            }
            Utils.mixpanelTrack(CONSTANTS.MX_AS_EVENTS.AS_SAVE_SEARCH_RENAMED, {
              newName: inputValue,
            });
            purchaseStatusPopupState.setToastMsg(
              null,
              null,
              null,
              null,
              null,
              str,
            );
            createSaveSearchState.setShowCreateSaveSearch(false);
          };
          currentSelectedState.updateSavedSearch(
            createSaveSearchState.updateValues.id,
            inputValue,
            '',
            updateSaveSearchCallback,
          );
        } else {
          const saveSearchCallback = (searchType, status = 'success') => {
            let str = '';
            if (status === 'success') {
              str = 'Search saved successfully';
              savedSearches(searchType);
            } else {
              str = 'Unable to save this search, please try again';
            }
            setIsLoading(false);
            Utils.mixpanelTrack(CONSTANTS.MX_AS_EVENTS.AS_SAVE_SEARCH_CREATED, {
              searchSaveName: inputValue,
            });
            purchaseStatusPopupState.setToastMsg(
              null,
              null,
              null,
              null,
              null,
              str,
            );
            createSaveSearchState.setShowCreateSaveSearch(false);
          };
          currentSelectedState.saveSearch(inputValue, '', saveSearchCallback);
        }
      } else {
        showErrorToolTip(true);
        setInputVal('');
      }
  };
  const submitAction = e => {
    showErrorToolTip(false);
    if (e.charCode === 13) createSaveSearch();
  };

  React.useEffect(() => {
    if (createSaveSearchState.showCreateSaveSearch) {
      if (createSaveSearchState.actionMethod === 'update') {
        setInputVal(createSaveSearchState.updateValues.name);
        setEmailFrequency(createSaveSearchState.updateValues.emailFrequency);
      } else {
        setInputVal('');
      }
      // eslint-disable-next-line no-undef
      if (document.getElementById('createSaveSearchInput') !== undefined)
        // eslint-disable-next-line no-undef
        document.getElementById('createSaveSearchInput').focus();
    }
  }, [createSaveSearchState.showCreateSaveSearch]);

  return createSaveSearchState.showCreateSaveSearch ? (
    <>
      <div className="create-saveSearch-popup common-popup">
        <div className="popup-wrap">
          <div
            className="popup-close"
            title="Click here to close"
            onClick={() => createSaveSearchState.setShowCreateSaveSearch(false)}
          >
            <CloseIcon />
          </div>
          <div className="title">
            {createSaveSearchState.actionMethod === 'create'
              ? 'Create a new '
              : 'Rename your '}
            Saved Search
          </div>
          <div className="popup-content-wrap">
            <input
              className="input-box"
              id="createSaveSearchInput"
              type="text"
              placeholder="Enter Search name"
              value={inputVal}
              onChange={e => changeInputVal(e.currentTarget.value)}
              onKeyPress={submitAction}
            />
            <div
              className="common-tooltip-error"
              style={{ display: errorToolTip ? 'block' : 'none' }}
            >
              <span className="top-arrow" />
              Please enter a name
            </div>
            {/* <div className="save-search-radio-wrap">
              <div className="text-msg">
                Email me new results for this search
              </div>
              <div className="radio-wrapper">
                <div
                  className={`radio-item${
                    emailFrequency === 'DAILY' ? ' selected' : ''
                  }`}
                  onClick={e => changeEmailFrequency(e, 'DAILY')}
                >
                  <div className="radio-svg-section">
                    <RadioInnerIcon className="radio-inner" />
                    <RadioOuterIcon className="radio-outer" />
                  </div>
                  <div className="radio-text">Daily</div>
                </div>
                <div
                  className={`radio-item${
                    emailFrequency === 'WEEKLY' ? ' selected' : ''
                  }`}
                  onClick={e => changeEmailFrequency(e, 'WEEKLY')}
                >
                  <div className="radio-svg-section">
                    <RadioInnerIcon className="radio-inner" />
                    <RadioOuterIcon className="radio-outer" />
                  </div>
                  <div className="radio-text">Weekly</div>
                </div>
                <div
                  className={`radio-item${
                    emailFrequency === 'NEVER' ? ' selected' : ''
                  }`}
                  onClick={e => changeEmailFrequency(e, 'NEVER')}
                >
                  <div className="radio-svg-section">
                    <RadioInnerIcon className="radio-inner" />
                    <RadioOuterIcon className="radio-outer" />
                  </div>
                  <div className="radio-text">Never</div>
                </div>
              </div>
            </div> */}
          </div>
          <div className="popup-action-wrap">
            <Button
              btnText={
                createSaveSearchState.actionMethod === 'create'
                  ? 'Create'
                  : 'Update'
              }
              icon={false}
              iconName=""
              type="button"
              className={`popup-action-btn positive-btn${
                isLoading ? ' loading' : ''
              }`}
              loader={isLoading}
              click={() => createSaveSearch()}
            />
            <div
              className="popup-action-btn"
              onClick={() =>
                createSaveSearchState.setShowCreateSaveSearch(false)
              }
            >
              Cancel
            </div>
          </div>
        </div>
      </div>
      <div
        className="common-popup-mask"
        onClick={() => createSaveSearchState.setShowCreateSaveSearch(false)}
      />
    </>
  ) : (
    ''
  );
});

export { CreateSaveSearch, createSaveSearchState };
export default CreateSaveSearch;
